module.exports = __webpack_public_path__ + "52fbe6d890bfffed2ce4a589c4a7ee1a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/clock-blue.png
// module id = 614
// module chunks = 0